import {
    GET_INVOICE_EMAIL_REQUEST, GET_INVOICE_EMAIL_SUCCESS, GET_INVOICE_EMAIL_ERROR,
    CREATE_INVOICE_EMAIL_REQUEST, CREATE_INVOICE_EMAIL_SUCCESS, CREATE_INVOICE_EMAIL_ERROR,
    GET_INVOICE_PENDING_REQUEST, GET_INVOICE_PENDING_SUCCESS, GET_INVOICE_PENDING_ERROR,
    CREATE_INVOICE_PENDING_REQUEST, CREATE_INVOICE_PENDING_SUCCESS, CREATE_INVOICE_PENDING_ERROR,
    GET_PDF_DOWNLOAD_REQUEST,
    GET_PDF_DOWNLOAD_SUCCESS,
    GET_PDF_DOWNLOAD_ERROR,
    GET_CREDIT_NOTE_EMAIL_REQUEST,
    GET_CREDIT_NOTE_EMAIL_SUCCESS,
    GET_CREDIT_NOTE_EMAIL_ERROR,
    CREATE_CREDIT_NOTE_EMAIL_REQUEST,
    CREATE_CREDIT_NOTE_EMAIL_SUCCESS,
    CREATE_CREDIT_NOTE_EMAIL_ERROR,
    GET_CN_PDF_DOWNLOAD_REQUEST,
    GET_CN_PDF_DOWNLOAD_SUCCESS,
    GET_CN_PDF_DOWNLOAD_ERROR,
    GET_DAMAGE_RECEIPT_EMAIL_REQUEST,
    GET_DAMAGE_RECEIPT_EMAIL_SUCCESS,
    GET_DAMAGE_RECEIPT_EMAIL_ERROR,
    CREATE_DAMAGE_RECEIPT_EMAIL_REQUEST,
    CREATE_DAMAGE_RECEIPT_EMAIL_SUCCESS,
    CREATE_DAMAGE_RECEIPT_EMAIL_ERROR,
    GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_REQUEST,
    GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS,
    GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_ERROR,
    CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_REQUEST,
    CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS,
    CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_ERROR,

} from "./types";
import moment from "moment";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");


export const getInvoiceEmail = (token, values) => (dispatch) => {
    dispatch({ type: GET_INVOICE_EMAIL_REQUEST });

    const data = {
        from_date: moment(values.fromDate).format("MM-DD-YYYY"),
        to_date: moment(values.toDate).format("MM-DD-YYYY"),
        factor_id: values.paymentClass === undefined ? null : values.paymentClass,
        customer_id: values.customer === undefined ? null : values.customer,
        order_status_id: values.status === undefined ? null : values.status,
    };


    return axios({
        method: "POST",
        url: `${BASEURL}getAll/selectInvoices`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: data
    }).then((response) => {
        return dispatch({
            type: GET_INVOICE_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_INVOICE_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const getCreditNoteEmail = (token, values) => (dispatch) => {
    dispatch({ type: GET_CREDIT_NOTE_EMAIL_REQUEST });

    const data = {
        from_date: moment(values.fromDate).format("MM-DD-YYYY"),
        to_date: moment(values.toDate).format("MM-DD-YYYY"),
        customer_id: (values.customer === undefined || values.customer === "All") ? null : values.customer,
        term_id: (values.term === undefined || values.term === "All") ? null : values.term,
        customer_type_id: (values.cutomer_category === undefined || values.cutomer_category === "All") ? null : values.cutomer_category,
    };


    return axios({
        method: "POST",
        url: `${BASEURL}getAll/ReturnEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: data
    }).then((response) => {
        return dispatch({
            type: GET_CREDIT_NOTE_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_CREDIT_NOTE_EMAIL_ERROR,
            payload: error.response,
        });
    });
};


export const createInvoiceEmail = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_INVOICE_EMAIL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/InvoiceEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [data]
    }).then((response) => {
        return dispatch({
            type: CREATE_INVOICE_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: CREATE_INVOICE_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const createInvoiceEmailTest = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_INVOICE_EMAIL_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}communication/OrderShippedConfirmationInvoiceEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [data]
    }).then((response) => {
        return dispatch({
            type: CREATE_INVOICE_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: CREATE_INVOICE_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const createCreditNoteEmail = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_CREDIT_NOTE_EMAIL_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}communication/sendCreditMemoEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [data]
    }).then((response) => {
        return dispatch({
            type: CREATE_CREDIT_NOTE_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: CREATE_CREDIT_NOTE_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const getInvoicePending = (token, values) => (dispatch) => {
    dispatch({ type: GET_INVOICE_PENDING_REQUEST });

    const data = {
        from_date: moment(values.fromDate).format("MM-DD-YYYY"),
        to_date: moment(values.toDate).format("MM-DD-YYYY"),
        customer_id: values.customer === undefined ? null : values.customer,
        factor_id: values.paymentClass === undefined ? null : values.paymentClass,
        payment_term_id: values.terms === undefined ? null : values.terms,
    };


    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InvoicePending`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: data
    }).then((response) => {
        return dispatch({
            type: GET_INVOICE_PENDING_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_INVOICE_PENDING_ERROR,
            payload: error.response,
        });
    });
};


export const createInvoicePending = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_INVOICE_PENDING_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/sendPendingInvoiceEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [data]
    }).then((response) => {
        return dispatch({
            type: CREATE_INVOICE_PENDING_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: CREATE_INVOICE_PENDING_ERROR,
            payload: error.response,
        });
    });
};

export const createInvoicePdfDownload = (token, selectedRows) => (dispatch) => {
    dispatch({ type: GET_PDF_DOWNLOAD_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/downloadInvoice`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [selectedRows],
        responseType: "arraybuffer",
    })
        .then((response) => {
            return dispatch({
                type: GET_PDF_DOWNLOAD_SUCCESS,
                payload: response?.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: GET_PDF_DOWNLOAD_ERROR,
                payload: error.response,
            });
        });
};

export const createCreditNotePdfDownload = (token, selectedRows) => (dispatch) => {
    dispatch({ type: GET_CN_PDF_DOWNLOAD_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}communication/downloadCreditMemo`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [selectedRows],
        responseType: "arraybuffer",
    })
        .then((response) => {
            return dispatch({
                type: GET_CN_PDF_DOWNLOAD_SUCCESS,
                payload: response?.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: GET_CN_PDF_DOWNLOAD_ERROR,
                payload: error.response,
            });
        });
};

export const getDamageReceiptEmail = (token, values) => (dispatch) => {
    dispatch({ type: GET_DAMAGE_RECEIPT_EMAIL_REQUEST });
    const data = {
        from_date: moment(values.fromDate).format("MM-DD-YYYY"),
        to_date: moment(values.toDate).format("MM-DD-YYYY"),
        customer_id: (values.customer === undefined || values.customer === "All") ? null : values.customer,
        term_id: (values.term === undefined || values.term === "All") ? null : values.term,
        customer_type_id: (values.cutomer_category === undefined || values.cutomer_category === "All") ? null : values.cutomer_category,
    };
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/damageEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: data
    }).then((response) => {
        return dispatch({
            type: GET_DAMAGE_RECEIPT_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_DAMAGE_RECEIPT_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const getActualDamageReceiptEmail = (token, values) => (dispatch) => {
    dispatch({ type: GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_REQUEST });
    const data = {
        date_from: moment(values.fromDate).format("MM-DD-YYYY"),
        date_to: moment(values.toDate).format("MM-DD-YYYY"),
        customer_id: (values.customer === undefined || values.customer === "All") ? null : values.customer,
        term_id: (values.term === undefined || values.term === "All") ? null : values.term,
        customer_type_id: (values.cutomer_category === undefined || values.cutomer_category === "All") ? null : values.cutomer_category,
    };
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/returnForMultipleDamageEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: data
    }).then((response) => {
        return dispatch({
            type: GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const createDamageReceiptEmail = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_DAMAGE_RECEIPT_EMAIL_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}communication/sendDamageMemoEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [data]
    }).then((response) => {
        return dispatch({
            type: CREATE_DAMAGE_RECEIPT_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: CREATE_DAMAGE_RECEIPT_EMAIL_ERROR,
            payload: error.response,
        });
    });
};

export const createActualDamageReceiptEmail = (token, data) => (dispatch) => {
    dispatch({ type: CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}communication/sendReturnForMultipleDamageEmail`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: [data]
    }).then((response) => {
        return dispatch({
            type: CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_ERROR,
            payload: error.response,
        });
    });
};